import config from "@/config";
import moment from "moment";

export default {
  install: (Vue, options) => {
    const LOGOUT = "user/logout";

    Vue.prototype.$helpers = {
      login() {
        options.$router.push("/login");
      },
      logout() {
        options.$store
          .dispatch(LOGOUT)
          .then(() => options.$router.push("/"))
          .catch(err => console.log(err));
      },
      handleFeedback(e) {
        let result = false;
        switch (e) {
          case "invalidToken":
            result = true;
            options.$store
              .dispatch(LOGOUT)
              .then(() => options.$router.push("/expired"))
              .catch(err => console.log(err));
            break;
          case "NoUserAccessRight":
            result = true;
            options.$store
              .dispatch(LOGOUT)
              .then(() => options.$router.push("/denied"))
              .catch(err => console.log(err));
            break;
          case "session_expired":
          case "sessionExpired":
            result = true;
            options.$store
              .dispatch(LOGOUT)
              .then(() => options.$router.push("/expired"))
              .catch(err => console.log(err));
            break;
          case "invalid_session":
          case "invalidSession":
            result = true;
            options.$store
              .dispatch(LOGOUT)
              .then(() => options.$router.push("/expired"))
              .catch(err => console.log(err));
            break;
          case "permission_denied":
          case "permissionDenied":
            result = false;
            // if (options.$store.getters.account[0].account_type == 2) {
            if (options.$store.getters.accountType == 2) {
              options.$store
                .dispatch(LOGOUT)
                .then(() => options.$router.push("/denied"))
                .catch(err => console.log(err));

              result = true;
            }
            break;
          case "close":
          case "CLOSE":
            result = true;
            options.$store
              .dispatch(LOGOUT)
              .then(() => options.$router.push("/expired"))
              .catch(err => console.log(err));
            break;
        }

        return result;
      },
      fontClassName(item, isNegative) {
        // isLink = isLink || false;
        isNegative = isNegative || false;
        if (parseFloat(item) < 0)
          return 'text-danger';
        else if (parseFloat(item) == 0)
          return '';
        else {
          // return 'text-info';
          if (isNegative == true)
            return 'text-danger';
          else
            return 'text-info';
        }
      },
      alert(title, message, variant) {
        return options.$swal(title, message, variant);
      },
      showDialog(title, message, variant) {
        options.$swal(title, message, variant);
      },
      showToast(title, message, variant) {
        options.$swal(title, message, variant);
      },
      showMatchInfo(title, message, variant) {
        return options.$swal(title, message, variant);
      },
      rowClass: function(item) {
        if (!item) return
        if (item.status.toUpperCase() === 'BLOCK' || item.status.toUpperCase() === 'SUSPEND') return 'table-warning'
        if (item.status.toUpperCase() === 'CLOSE')  return 'table-info'
        if (item.status.toUpperCase() === 'FREEZE')  return 'table-danger'
      },
      rowClassBit: function(item) {
        if (item == null) return
        if (item == false) return 'table-warning'
      },
      rowClassBitPromo: function(status) {
        if (status == null) return
        if (status == false) return 'table-warning'
      },
      rowClassTicket: function(item, type) {
        if (!item) return
        if (type == 'deposit') {
          if (item.target_bank_id.toUpperCase() != 'GATEWAY')  return 'table-info'
        }

        if (type == 'withdrawal' && item.ref_no) {
          if (item.ref_no.toUpperCase() == 'FIRSTWITHDRAWAL')  return 'table-success'
        }
      },
      colClass: function(item) {
        if (!item) return
        if (item.toUpperCase() === 'ACTIVE')  return 'table-success'
        if (item.toUpperCase() === 'BLOCK' || item.toUpperCase() === 'SUSPEND') return 'table-warning'
        if (item.toUpperCase() === 'CLOSE' || item.toUpperCase() === 'RESET')  return 'table-info'
        if (item.toUpperCase() === 'FREEZE')  return 'table-danger'
      },
      badgeClass: function(item) {
        if (!item) return
        if (item.toUpperCase() === 'ACTIVE' || item.toUpperCase() === 'PROCESSED')  return 'badge badge-success'
        if (item.toUpperCase() === 'BLOCK' || item.toUpperCase() === 'SUSPEND' || item.toUpperCase() === 'PENDING' || item.toUpperCase() === 'ONLOAD' || item.toUpperCase() == 'PROCESSING') return 'badge badge-warning'
        if (item.toUpperCase() === 'CLOSE' || item.toUpperCase() === 'RESET' || item.toUpperCase() === 'REVIEW')  return 'badge badge-info'
        if (item.toUpperCase() === 'FREEZE' || item.toUpperCase() === 'REJECTED')  return 'badge badge-danger'
        if (item.toUpperCase() === 'AUDIT')  return 'badge badge-primary'
      },
      ticketStatusWoBadgeClass: function(item) {
        if (!item) return
        if (item.toUpperCase() === 'ACTIVE' || item.toUpperCase() === 'PROCESSED')  return 'font-weight-bold text-success'
        if (item.toUpperCase() === 'BLOCK' || item.toUpperCase() === 'SUSPEND' || item.toUpperCase() === 'PENDING' || item.toUpperCase() === 'ONLOAD' || item.toUpperCase() == 'PROCESSING') return 'font-weight-bold text-warning'
        if (item.toUpperCase() === 'CLOSE' || item.toUpperCase() === 'RESET' || item.toUpperCase() === 'REVIEW')  return 'font-weight-bold text-info'
        if (item.toUpperCase() === 'FREEZE' || item.toUpperCase() === 'REJECTED')  return 'font-weight-bold text-danger'
        if (item.toUpperCase() === 'AUDIT')  return 'font-weight-bold text-primary'
      },
      isNumeric(str) {
        return /^\d+$/.test(str);
      },
      getTicketId(refNo) {
        if (refNo.includes("@") == false && refNo.includes("A") == false)
          return refNo;

        if (refNo.includes("@") == true) {
          var arr = refNo.split("@");
          return arr[1];
        } else if (refNo.includes("AB") == true) {
          var arr = refNo.split("AB");
          return arr[1];
        } else {
          var arr = refNo.split("A");
          return arr[1];
        }
      },
      checkImg(imageName, file) {
        const allowedTypes = ["image/png", "image/jpeg"];
        if(imageName === "") {
          this.showToast("error", options.$t.messages[options.$t.locale].message.pleaseSelectAnImage, "error");
          $("#upload-logo-btn")[0].value = '';
          return true;
        }
        if(!allowedTypes.includes(file.type)) {
          this.showToast("error", options.$t.messages[options.$t.locale].message.pleaseSelectAValidImageType, "error");
          $("#upload-logo-btn")[0].value = '';
          return true;
        }
        if(file.size > 1000000) {
          this.showToast("error", options.$t.messages[options.$t.locale].message.imageTooLargeMaxSizeAllowedIsOneMb, "error");
          $("#upload-logo-btn")[0].value = '';
          return true;
        }
        return false;
      },
      showActionButton(action) {
        if (options.$store.getters.authorityRole == 'SUB_PRI') {
          if (options.$store.getters.accountAuthority) {
            var roles = options.$store.getters.accountAuthority[0].authority_option;
            roles = roles && roles.length > 0 ? roles.split(',') : [];
            if (roles.includes(action)) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return action.slice(0,4) == "e_" ? false : true;
        }
      },
      getPaymentGatewayRefNo(ticketID, paymentGateway, paymentMode) {
        if (paymentGateway == null) return "";
      },

      getPaymentGatewayRefNoSetOp(ticketID, paymentGateway, paymentMode) {
        if (paymentGateway == null) return "";

        let code = "";
        switch(paymentGateway.trim().toUpperCase()) {
          case "XFTUSDT":
            code = "XFD";
            break;
          case "SULIFUUSDT":
            code = "SUD";
            break;
          case "USOTCUSDT":
            code = "UST";
            break;
          case "UBITUSDT":
            code = "UBI";
            break;
          case "PPPAYUSDT":
            code = "PPT";
            break;
        }

        return config.pgIDPrefix + code + paymentMode + "@" + ticketID;
      },
      getPaymentGatewayRefNoSetMember(bankID, ticketID, prefix, delimiter) {
        if (bankID == "GATEWAY")
          return config.pgMemberIDPrefix + prefix + delimiter + ticketID;
        else
          return "";
      },
      selectText: function(element) {
        let doc = document;
        let text = doc.getElementById(element);
        let range, selection;
    
        if (doc.body.createTextRange) {
          range = document.body.createTextRange();
          range.moveToElementText(text);
          range.select();
        } else if (window.getSelection) {
          selection = window.getSelection();
          range = document.createRange();
          range.selectNodeContents(text);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      },
      showExportAll(dateRange) {
        if (moment(dateRange.endDate).diff(moment(dateRange.startDate), 'days') > 61)
          return false;
        else
          return true;
      },
      hideChildMenu() {
        $('.main-sidebar .sidebar-menu > li').each(function () {
          const me = $(this);

          if (me.find('> .dropdown-menu').length) {
            if(!me.find('> .dropdown-menu > .dropdown-menu-item').hasClass('active')) {
              if(me.hasClass('show')) {
                me.removeClass('show')
              }
            } else {
              if(!me.hasClass('show')) me.addClass('show')
            }
            me.find('> .dropdown-menu').hide();
            me.find('> .dropdown-menu').prepend(`<li class="dropdown-title pt-3">${me.find('> a').text()}</li>`);
          } else {
            me.find('> a').attr('data-toggle', 'tooltip');
            me.find('> a').attr('data-original-title', me.find('> a').text());
            $('[data-toggle="tooltip"]').tooltip({
              placement: 'right',
              trigger : 'hover'  // Prevent on click button the tooltip still around and wont disappear
            });

            // Prevent on click button the tooltip still around and wont disappear
            $('[data-toggle="tooltip"]').on('click', function () {
              $(this).tooltip('hide')
          })
          }
        });
      }
    }
  }
};
